import { render } from "./NewEmployee.vue?vue&type=template&id=fa35c918&scoped=true"
import script from "./NewEmployee.vue?vue&type=script&lang=js"
export * from "./NewEmployee.vue?vue&type=script&lang=js"

import "./NewEmployee.vue?vue&type=style&index=0&id=fa35c918&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fa35c918"

export default script